var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProteinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u56FE\\u5C42_1",
    "data-name": "\\u56FE\\u5C42 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 44 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m20.25,15.75l-5.91-10.88c-.78-1.44-2.59-1.98-4.04-1.19-1.44.78-1.98,2.59-1.19,4.04l5.63,10.36v19.64c0,1.64,1.33,2.98,2.98,2.98s2.98-1.33,2.98-2.98v-20.1c0-.26-.03-.51-.09-.75-.04-.39-.16-.77-.35-1.11Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m7.69,8.53c-.78-1.44-2.59-1.98-4.04-1.19-1.44.78-1.98,2.59-1.19,4.04l5.91,10.88c.78,1.44,2.59,1.98,4.04,1.19,1.44-.78,1.98-2.59,1.19-4.04l-5.91-10.88Zm27.19-.47c.78-1.44.25-3.25-1.19-4.04-1.44-.78-3.25-.25-4.04,1.19l-5.91,10.88c-.14.26-.25.55-.3.84-.05.22-.08.45-.08.67v20.1c0,1.64,1.33,2.98,2.98,2.98s2.98-1.33,2.98-2.98v-19.4l5.57-10.25Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m40.34,7.68c-1.44-.78-3.25-.25-4.04,1.19l-5.91,10.88c-.78,1.44-.25,3.25,1.19,4.04,1.44.78,3.25.25,4.04-1.19l5.91-10.88c.78-1.44.25-3.25-1.19-4.04Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProteinIcon);
export default __webpack_public_path__ + "static/media/protein-icon.ed8489c8053a2df58f7ea2a26f5eb395.svg";
export { ForwardRef as ReactComponent };